// Everything in this file must be imported or prefixed with window
// to avoid "Uncaught ReferenceError: <variable> is not defined"
import { Backbone } from "js/vendor-backbone";

const $ = window.$;
const _ = window._;

export {
    $,
    _,
    Backbone,
};
